// extracted by mini-css-extract-plugin
export default {"Back":"BackPageButton_Back__OB8ss","Link":"BackPageButton_Link__OyvRI"};